// @flow

import Cookie from 'js-cookie';
const BUILD_ENV_PREFIX = process.env.BUILD_ENV_PREFIX || '';
const COOKIE_NAME = `${BUILD_ENV_PREFIX}current_merchant_group_id`;
const COOKIE_DOMAIN = process.env.NODE_ENV === 'test' ? '' : 'powerreviews.com';

// cleanup after migrating from localStorage to cookie
localStorage.removeItem('MerchantGroup.Selected');

export const getSelected = () => {
  const item = Cookie.get(COOKIE_NAME);

  return item != null ? +item : null;
};

export const setSelected = (val: ?number) => {
  if (val == null) return;

  Cookie.set(COOKIE_NAME, val, {
    domain: COOKIE_DOMAIN,
    expires: 30,
    sameSite: 'strict',
  });
};

export const getState = () => {
  return {
    currentClient: getSelected(),
  };
};

export default {
  getSelected,
  setSelected,
  getState,
};



// WEBPACK FOOTER //
// ./src/containers/client/storage.js